<template>
  <div>
    <Modal class="text-left" v-if="error">
      <h2 class="h3 mb-4">Invalid URL</h2>

      <p class="lead">Provided URL isn't supported  by Superchargify AMP. Please provide URL of a product, collection or blog post.</p>
      <p class="lead">If you think that this is a mistake, please reach out to us via live chat widget or email us at <a href="mailto:support@superchargify.com">support@superchargify.com</a>.</p>

      <router-link to="/" class="font-weight-normal">&lsaquo; Go back</router-link>
    </Modal>
    <div class="left part">
      <router-link to="/"><Logo height="32" alt="Superchargify Logo" class="mb-5" /></router-link>
      <div class="mb-3" v-if="ready">
        <p class="font-weight-normal mb-1">Scan this QR code to preview AMP page on your phone.</p>
        <div>
          <QrCode :value="urls.amp" :options="qrOptions" />
        </div>
        <div class="mb-3">
          <input class="form-control form-control-lg" :value="urls.amp" readonly>
        </div>
        <div>
          <router-link to="/" class="small">&lsaquo; Go back</router-link>
          &bull;
          <a :href="urls.google" class="small" target="_blank" rel="noopener">Open in Google AMP Test tool</a>
          &bull;
          <a :href="urls.original" class="small" target="_blank" rel="noopener">Open original page</a>
        </div>
      </div>
      <div class="loader" v-else>Loading...</div>
      <Footer class="mt-3" />
    </div>
    <iPhone :url="urls.amp" :ready="ready" v-if="$mq !== 'sm'" />
  </div>
</template>

<script>
import QrCode from '@chenfengyuan/vue-qrcode'

import Logo from '@/components/Logo'
import iPhone from '@/components/iPhone'
import Footer from '@/components/Footer'
import Modal from '@/components/Modal'

export default {
  components: {
    Logo,
    iPhone,
    QrCode,
    Footer,
    Modal
  },
  created () {
    if (!this.url ||
        !this.url.startsWith('https://')) {
      this.$router.replace({ name: 'home' })
    }
  },
  computed: {
    url () {
      return this.$route.query.url
    },
    urls () {
      const urls = {}

      if (this.url.includes('/a/sc/amp/')) {
        urls.amp = this.url
        urls.original = this.url.replace('/a/sc/amp', '')
      } else {
        const u = new URL(this.url)

        urls.amp = [u.origin, '/a/sc/amp', u.pathname].join('')
        urls.original = this.url
      }

      urls.google = 'https://search.google.com/test/amp?utm_source=superchargify&utm_medium=preview&utm_campaign=amppreview&url=' + encodeURIComponent(urls.amp)

      return urls
    },
    qrOptions () {
      return {
        width: 250,
        color: {
          dark: '#102A43',
          light: '#0000'
        }
      }
    }
  },
  mounted () {
    if (!this.url) return

    if (!(this.url.includes('/products/') ||
          this.url.includes('/collection') ||
          this.url.includes('/blogs/'))) {
      this.error = true
      return
    }

    const u = new URL(this.url)
    this.ping(`/ping/${u.host}`)
  },
  data () {
    return {
      input: null,
      ready: false,
      error: false
    }
  },
  methods: {
    async ping (pingUrl) {
      try {
        const response = await fetch(pingUrl)
        const text = await response.text()

        if (text && text.trim() === 'PONG') {
          if (['xs', 'sm'].includes(this.$mq)) {
            window.location = this.urls.amp
          } else {
            this.ready = true
          }
        } else {
          throw new Error('Invalid Ping Response')
        }
      } catch (e) {
        this.error = true
      }
    }
  }
}
</script>

<style lang="scss">
.part {
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 0;

  &.right {
    position: relative;
    justify-content: flex-start;
  }

  &.left {
    overflow: auto;
  }
}

input[readonly] {
  background-color: #F0F4F8!important;
  border: 2px solid #D9E2EC;
  color: #627D98;
}
</style>
